import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=c8140084&scoped=true&"
import script from "./FileBrowser.vue?vue&type=script&lang=js&"
export * from "./FileBrowser.vue?vue&type=script&lang=js&"
import style0 from "./FileBrowser.vue?vue&type=style&index=0&id=c8140084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8140084",
  null
  
)

export default component.exports